import moment from 'moment';

export const TimeStampToDate = (data) => {
	var a = new Date(data * 1000)
	var months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	]
	var year = a.getFullYear()
	var month = months[a.getMonth()]
	var date = a.getDate()
	var time = date + " " + month + " " + year
	return time
}

export const TimeStampToTime = (data) => {
	const time_to_show = data
	const t = new Date(time_to_show * 1000)
	const formatted =
		("0" + t.getHours()).slice(-2) + ":" + ("0" + t.getMinutes()).slice(-2)
	return formatted
}

export const MongoTimeConvert = (time) => {
//    console.log("TimeDate",time)
	const localDate = moment(time);
	const now = moment(Date.now());
	const localDateSec = parseInt(moment.duration(localDate).asSeconds())
	const nowSec = parseInt(moment.duration(now).asSeconds())
	const str = moment.duration(nowSec-localDateSec, 'seconds').humanize()
	return `${str[0].toUpperCase() + str.slice(1)} ago`
}
